import { NodeInterface } from '@swivl-mono/types';
import TabNodeLayoutData, {
  TabNodePositionalData,
} from '../NodeLayouts/TabNodeLayoutData';
import NodePanel, { NodePanelProps } from './NodePanel';
import SSKeyValueInput from '../../../../Components/SSKeyValueInput/SSKeyValueInput';
import InspectorFooter from '../SidePanel/Inspector/components/InspectorFooter';
import InspectorNodeHeader from '../SidePanel/Inspector/components/InspectorNodeHeader';
import { Dropdown } from '@swivl-mono/ui';
import { RandomId } from '@swivl-mono/helpers';

const Action = {
  Type: 'action',
  Empty: function () {
    return {
      id: RandomId(6),
      type: Action.Type,
      delay: 0,
      showTyping: false,
      action: 'apiRequest',
      name: 'API Request',
      method: 'GET',
      params: {
        endpoint: '',
        postValues: [],
        saveValues: [],
      },
      outputs: [
        { id: RandomId(6), name: 'onSuccess', title: '', onCompleteGoto: null },
      ],
    };
  },
  PlumbData: function (node: NodeInterface) {
    return TabNodeLayoutData({
      node: node,
      label: 'ACTION',
      title: 'API Request',
      baseWidth: 130,
      tabs: node.outputs.map((output: any, index: number) => ({
        id: 'outputs_' + output.id + '_onCompleteGoto',
        source: 'outputs_' + index + '_onCompleteGoto',
        target: output.onCompleteGoto,
      })),
    });
  },
  InspectorPanel: class ActionInspectorPanel extends NodePanel {
    constructor(props: NodePanelProps) {
      super(props);
      this.addPostValue = this.addPostValue.bind(this);
      this.addSaveValue = this.addSaveValue.bind(this);
      this.state = { action: this.props.node.action };
    }

    addPostValue() {
      let kvData = { id: RandomId(6), from: '', to: '' };
      this.addItemToArray(kvData, 'params.postValues', false);
    }
    addSaveValue() {
      let kvData = { id: RandomId(6), from: '', to: '' };
      this.addItemToArray(kvData, 'params.saveValues', false);
    }

    render() {
      var self = this;
      var masterOutputs:any[] = [];
      var actionArray: any[] = [];
      let actionID;
      let node = this.props.node;
      if ((this.state as any).action !== this.props.node.action) {
        if (this.props.node.action == 'createUpdateContact') {
          actionArray = [
            'email',
            'firstname',
            'lastname',
            'website',
            'company',
            'phone',
            'address',
            'leadStatus',
          ];
        }
        if (this.props.node.action == 'createCompany') {
          actionArray = ['domain', 'name'];
        }
        if (this.props.node.action == 'updateCompany') {
          actionArray = ['domain', 'name'];
        }
        if (this.props.node.action == 'createDeal') {
          actionArray = ['dealname', 'amount', 'pipeline', 'dealstage'];
        }
        if (this.props.node.action == 'updateDeal') {
          actionArray = ['dealname', 'amount', 'pipeline', 'dealstage'];
        }

        for (var i = 0; i < actionArray.length; i++) {
          let kvData = { id: RandomId(6), from: actionArray[i], to: '' };
          masterOutputs.push(kvData);
        }
        node.params.postValues = masterOutputs;
        node.params.saveValues = { id: RandomId(6), from: actionID, to: '' };
        this.props.updateNode(node, this.props.node, false);
        this.setState({ action: this.props.node.action });
      }
      let postValues, saveValues, content;
      if (
        self.props.node.params.postValues &&
        self.props.node.action == 'apiRequest'
      ) {
        postValues = self.props.node.params.postValues.map(function (
          item: any,
          index: any
        ) {
          return (
            <SSKeyValueInput
              key={item.id}
              keyValue={item.to}
              valueValue={item.from}
              onChange={self.onChange}
              isValueAVariable={false}
              moveItemInArray={self.moveItemInArray}
              keyKey="to"
              valueKey="from"
              arrayName="params.postValues"
              arrayIndex={index}
              delete={self.deleteValue}
            />
          );
          //
          // return <InspectorKeyValuePair key={item.id}
          //         leftIsUserVariables={true}
          //         rightIsUserVariables={false}
          //         leftKey="from"
          //         rightKey="to"
          //         userVariables={self.props.userVariables}
          //         item={item}
          //         items={self.props.node.params.postValues}
          //         moveItemsInOrderedObject={self.moveItemInArray}
          //         arrayName="params.postValues"
          //         arrayIndex={index}
          //         onChange={self.onChange}
          //         deleteValue={self.deleteValue}
          //         moveItemInArray={self.moveItemInArray}
          //         allowTextInput={true}
          //         entities={self.props.entities}
          //
          //
          // />
        });
      }
      if (
        self.props.node &&
        self.props.node.params &&
        self.props.node.params.saveValues &&
        self.props.node.action == 'apiRequest'
      ) {
        saveValues = self.props.node.params.saveValues.map(function (
          item: any,
          index: any
        ) {
          return (
            <SSKeyValueInput
              key={item.id}
              keyValue={item.from}
              valueValue={item.to}
              onChange={self.onChange}
              isValueAVariable={true}
              moveItemInArray={self.moveItemInArray}
              keyKey="from"
              valueKey="to"
              arrayName="params.saveValues"
              arrayIndex={index}
              delete={self.deleteValue}
            />
          );
          //
          // return <InspectorKeyValuePair key={item.id}
          //         leftIsUserVariables={false}
          //         rightIsUserVariables={true}
          //         leftKey="from"
          //         rightKey="to"
          //         userVariables={self.props.userVariables}
          //         item={item}
          //         items={self.props.node.params.saveValues}
          //         moveItemsInOrderedObject={self.moveItemsInOrderedObject}
          //         arrayName="params.saveValues"
          //         arrayIndex={index}
          //         entities={self.props.entities}
          //
          //         onChange={self.onChange}
          //         deleteValue={self.deleteValue}
          //         moveItemInArray={self.moveItemInArray}
          //         allowTextInput={true}
          // />
        });
      }

      content = (
        <div>
          Method:
          <div>
            <select
              value={this.props.node.method}
              name="method"
              onChange={this.onChange}
            >
              <option value="GET">GET</option>
              <option value="POST">POST</option>
            </select>
          </div>
          <input
            className="endpointInput"
            value={this.props.node.params.endpoint}
            onChange={this.onChange}
            name="params.endpoint"
            placeholder="Endpoint..."
          />
          <div className="actionHeader">Send Values:</div>
          {postValues}
          <div className="addElementButton" onClick={this.addPostValue}>
            + ADD SEND VALUE
          </div>
          <div className="actionHeader">Save Values:</div>
          {saveValues}
          <div className="addElementButton" onClick={this.addSaveValue}>
            + ADD SAVE VALUE
          </div>
        </div>
      );

      var options = [
        {
          value: 'apiRequest',
          id: 'apiRequest',
          label: 'API Request',
          key: '0',
        },
      ];

      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Action" />
            <div className="actionType">
              <Dropdown
                options={options}
                value={this.props.node.action}
                onChange={this.onChange}
                name="action"
              />
            </div>
            {content}
            <div className="carouselPadding">.</div>
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
          />
        </div>
      );
    }
  },
};
export default Action;
